export default {
  formatRequest: () => (logs, prefixTitle) => logs
    .filter(item => item.request_body)
    .map((item, index) => ({
      fileName: `${prefixTitle} ${index + 1} - ${item.request_uri}.json`,
      fileContent: item.request_body,
      mimeType: 'application/json',
    })),

  formatResponse: () => (logs, prefixTitle) => {
    const fileTypes = {
      json: (item, index) => ({
        fileName: `${prefixTitle} ${index + 1} - ${item.request_uri}.json`,
        fileContent: item.response_body,
        mimeType: 'application/json',
      }),
      xml: (item, index) => ({
        fileName: `${prefixTitle} ${index + 1} - ${item.request_uri}.xml`,
        fileContent: item.response_xml,
        mimeType: 'application/xml',
      }),
    };

    return logs
      .filter(item => item.response_body || item.response_xml)
      .map((item, index) => {
        const type = item.response_body ? 'json' : 'xml';

        return fileTypes[type](item, index);
      });
  },
  logsRequest(state, getters) {
    const { logs = [] } = state;

    return getters.formatRequest(logs, 'Request');
  },
  errorLogsRequest(state, getters) {
    const { errorLogs = [] } = state;

    return getters.formatRequest(errorLogs, 'Request');
  },
  logsResponse(state, getters) {
    const { logs = [] } = state;

    return getters.formatResponse(logs, 'Response');
  },
  errorLogsResponse(state, getters) {
    const { errorLogs = [] } = state;

    return getters.formatResponse(errorLogs, 'Response');
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/api/store/getters.js